export default __webpack_public_path__ + "static/media/screen-accordion-img.acc1ee98.png";